import { CalendarDateTime, toZoned } from "@internationalized/date"
import { loadStripe } from "@stripe/stripe-js"

import DefaultFavicon from "@/assets/logos/inflow/inflow-favicon.svg"

export const STRIPE_PROMISE = loadStripe(import.meta.env.VITE_STRIPE_KEY)

export const DEFAULT_HELP_EMAIL = "info@inflowsystems.com"
export const DEFAULT_HELP_PHONE = "+14142938625"
export const DEFAULT_ONSITE_HELP_TITLE = "Parking Ambassador"
export const DEFAULT_TIME_ZONE = "America/Chicago"

export const DEFAULT_TITLE = "Inflow™ Parking Systems"
export const DEFAULT_FAVICON = DefaultFavicon
export const DEFAULT_APPLE_ICON = DefaultFavicon

export const POLICIES_UPDATED_DATE = toZoned(
  new CalendarDateTime(2025, 12, 1, 0, 0, 0),
  "America/Chicago"
)

// Not found route data types
export const NOT_FOUND_SESSION = "session"
